import React, { Component } from 'react'
import T from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'
import { Route, Redirect, withRouter, Switch } from 'react-router-dom'
import * as ROUTE from 'constants/appRouting'
import UserManager from 'components/main/UserManager'
import App from 'routes/App'
import Auth from 'routes/Auth'
import Exception from 'routes/Exception'
import 'styles/bootstrap/bootstrap.scss'
import 'styles/layout.scss'
import 'styles/theme.scss'
import 'styles/ui.scss'
import { checkPathInApps } from 'helpers/apps-menu'
import { setWindowSizes } from 'reducers/layout/reducer'
import debounce from 'helpers/debounce'
import { updateDeepLink } from 'reducers/profile/reducer'
import { changeLang } from 'reducers/locale/reducer'
import MaintenancePage from 'routes/MaintenancePage'

const env = window._env

const isTruthyEnvFlag = value =>
  value === true || value === 'true' || value === '1'

class Main extends Component {
  componentDidMount() {
    this.checkAuthorized()
    window.onresize = this.onWindowResize
  }

  componentDidUpdate(prevProps) {
    this.checkAuthorized(prevProps)
  }

  onWindowResize = e => {
    debounce(
      this.props.setWindowSizes({
        width: e.currentTarget.innerWidth,
        height: e.currentTarget.innerHeight,
      }),
      500,
    )
  }

  checkAuthorized = prevProps => {
    const {
      history,
      isAuth,
      lastApplicationUrl,
      applications,
      locale,
      changeLang,
      updateDeepLink,
      deepLink,
      location: { pathname, search, state },
    } = this.props
    const currentLocale = localStorage.getItem('lang')
    const verificationRoute = ROUTE.MONITORS_AND_ALERTS
    const oldPathname = state ? state.pathname : ''
    const oldSearchParams = state ? state.search : ''

    if (!isAuth && !this.isOnLoginRoute() && pathname === verificationRoute) {
      const queryProps = {
        pathname: ROUTE.LOGIN,
        state: {
          pathname,
          search,
        },
      }

      history.replace(queryProps)
    }

    if (isAuth && this.isOnLoginRoute() && oldPathname === verificationRoute) {
      const queryProps = {
        pathname: oldPathname,
        search: oldSearchParams,
      }

      history.replace(queryProps)
    }

    if (!isAuth && !this.isOnLoginRoute()) {
      if (pathname !== '/') {
        updateDeepLink(`${pathname}${search}`)
      }

      history.replace(ROUTE.LOGIN)
    }

    if (isAuth && this.isOnLoginRoute() && deepLink && deepLink !== '') {
      history.replace(deepLink)
      updateDeepLink('')

      return
    }

    if (
      isAuth &&
      this.isOnLoginRoute() &&
      (prevProps === undefined ||
        prevProps.lastApplicationUrl !== lastApplicationUrl)
    ) {
      history.replace(
        checkPathInApps(lastApplicationUrl, applications)
          ? lastApplicationUrl
          : ROUTE.APPS,
      )
    }

    if (isAuth && (pathname === '/' || pathname === '/index.html')) {
      history.replace(ROUTE.APPS)
    }

    if (isAuth && currentLocale !== locale) {
      changeLang(locale)
    }
  }

  isOnLoginRoute = () => Boolean(window.location.href.match(ROUTE.AUTH))

  render() {
    const { featureFlags = {}, maintenanceMode } = this.props

    if (maintenanceMode || isTruthyEnvFlag(env.REACT_APP_MAINTENANCE_PAGE)) {
      return <MaintenancePage />
    }

    return (
      <div
        id="app-inner"
        className={cn({
          'header-new': featureFlags.APP_HEADER_V2,
        })}>
        <div className="preloaderbar hide">
          <span className="bar" />
        </div>
        <div
          className={cn('app-main h-100 fixed-header nav-collapsed', {
            'sidebar-sm': 'small',
          })}>
          <UserManager />
          <Switch>
            <Route path={ROUTE.AUTH} component={Auth} />
            <Route path={ROUTE.ERROR} component={Exception} />
            <Route path={ROUTE.APP} component={App} />
            <Redirect to={ROUTE.ERROR_404} />
          </Switch>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  isAuth: T.bool.isRequired,
}

export default connect(
  state => ({
    windowSizes: state.getIn(['layout', 'windowSizes']),
    isAuth: state.getIn(['profile', 'isAuth']),
    locale: state.getIn(['profile', 'profile', 'locale']),
    applications: state.getIn(['profile', 'profile', 'applications']),
    lastApplicationUrl: state.getIn([
      'profile',
      'profile',
      'lastApplicationUrl',
    ]),
    maintenanceMode: state.getIn(['maintenance', 'maintenanceMode']),
    deepLink: state.getIn(['profile', 'profile', 'deepLink']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    setWindowSizes,
    changeLang,
    updateDeepLink,
  },
)(withRouter(Main))
